import { FormValues } from '../types';

export const validateLoginForm = (values: FormValues) => {
  const errors: string[] = [];
  
  if (!values.email) {
    errors.push('Email is required');
  }
  
  if (!values.password) {
    errors.push('Password is required');
  }
  
  return {
    isValid: errors.length === 0,
    message: errors.join(', ')
  };
};